export default __webpack_public_path__ + "static/media/user.ea537e1b.svg";